<template>
    <span :class="priceClasses" v-if="instance.market !== VehicleInstanceMarkets.NONE">
        <span class="vehicle-price" v-if="price > 0"><span :class="`currency-symbol-${currencySymbolSize}`">{{ currencySymbol }}</span>{{ formatNumber(price) }}</span>
        <span class="vehicle-price" v-else><span :class="`currency-symbol-${currencySymbolSize}`">{{ currencySymbol }}</span>TBC</span>
        <div style="font-size: 1rem;" class="subtle" v-if="instance.retail_price && showMonthlyPrice"><span :class="`currency-symbol-${currencySymbolSize}`">{{ currencySymbol }}</span>{{ getVehicleMonthly(instance.retail_price) | formatNumber }} p/m</div>
        <span class="vehicle-price-vat" v-if="instance.is_vat_qualifier && showVatStatus">{{ text }}</span>
    </span>
</template>

<style scoped>
    .currency-symbol-small {
       font-size: .7em;
        font-weight: 300;
    }
    .vehicle-price-data .vehicle-price {
        font-size: 1.3em;
        font-weight: 500;
    }

    .vehicle-price-data.vehicle-written-off .vehicle-price {
        text-decoration: line-through;
    }

    .vehicle-price-data .vehicle-price-vat {
        color: #ccc;
        font-weight: 200;
        display: block;
        font-size: .7rem;
    }
</style>

<script>
    import Filters from '../../filters';
    import { VatService } from '../../classes/VatService';
    import { VehicleInstanceMarkets, VehicleLifeCycleStatuses } from '../../classes/Api/Vehicle';
    import {currency} from "../../filters/financial";
    import {currencySymbol, currencySymbolSize} from "../../../ts/Accounts/localisation";
    import {formatNumber} from "../../filters/numeric";

    export default {
        filters: Filters,
        props: { 
            instance: { 
                default() { } 
            }, 
            vatCalculationInclusive: { 
                default() { return false; } 
            },
            showVatStatus: {
                default() { return false; }
            },
            showMonthlyPrice: {
                default() { return false; }
            }
        },
        data() {
            return {
                currencySymbol,
                currencySymbolSize,
                VehicleInstanceMarkets,
            }
        },
        computed: {
            price() {
                let vat = new VatService();
                if (!this.vatCalculationInclusive && this.instance.is_vat_qualifier) {
                    return vat.unvatify(this.instance.retail_price);
                }

                return this.instance.retail_price;
            },
            text() {
                return this.vatCalculationInclusive ? 'inc VAT' : '+ VAT'
            },
            priceClasses() {
                let text = 'vehicle-price-data'

                if (VehicleLifeCycleStatuses.WRITTEN_OFF === this.instance.life_cycle_status) {
                    text += ' vehicle-written-off'
                }

                return text;
            }
        },
        methods: {
            formatNumber,
            currency,
            getVehicleMonthly(cost) {
                if (cost > 0) {
                    let deposit = 250;
                    let admin = 199 + 10;
                    let term = 48;
                    let apr = 6;

                    let interest = apr / 100 / 12;
                    let principal = (parseFloat(cost) + admin) - deposit;

                    let x = Math.pow(1 + interest, term);
                    let monthly = (principal*x*interest)/(x-1);

                    return monthly;
                }
            }
        }
    }
</script>